module.exports = __webpack_public_path__ + "static/media/no_followers.d8e24f6a.png";